// extracted by mini-css-extract-plugin
export var growableInput = "_af-0";
export var tagContainer = "_af-2";
export var textInput = "_af-1";